
import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as jsYaml from 'js-yaml';

if (environment.production) {
  enableProdMode();
}

(async () => {
  const response = await fetch('config/config.yaml');

  const yamlConfig = await response.text();
  environment.config = jsYaml.load(yamlConfig);

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
})();
